import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

const FAQS = [
  {
    q: "Ho già un sito e un dominio acquistato: come funziona?",
    a: "Il dominio resta tuo e non si tocca: dal pannello del tuo provider cambiamo una sola impostazione (DNS) per puntarlo al nuovo sito. Il vecchio sito resta online finché il nuovo non è pronto, quindi zero disservizio. Se usi una email sul tuo dominio (es. info@tuocontrollo.it), viene preservata: continui a ricevere le mail come sempre.",
  },
  {
    q: "Quanto dura la realizzazione?",
    a: "In media 3–5 settimane dal briefing al lancio, in base alla tempestività di foto, testi e menu. Un sito di poche pagine può partire ancora prima.",
  },
  {
    q: "Devo occuparmi io della parte tecnica?",
    a: "No. Hosting, dominio, aggiornamenti e sicurezza sono inclusi: noi gestiamo tutto e ti formiamo solo su ciò che ti serve gestire da solo (menu, prezzi, gallerie).",
  },
  {
    q: "Che materiale devo fornire?",
    a: "Tutto ciò che è recuperabile online lo recuperiamo noi: testi, recensioni, foto pubbliche, schede Google. Ciò che non è disponibile online (foto interne, menu aggiornati, orari) ce lo invii comodamente via email o WhatsApp.",
  },
  {
    q: "Funziona anche nella mia città piccola?",
    a: "Sì, anzi è lì che funziona meglio: nelle città piccole la SEO locale (Google Maps e ricerche «vicino a me») ha meno concorrenza e chi è ben posizionato prende i clienti degli altri.",
  },
  {
    q: "Posso aggiornare i contenuti da solo?",
    a: "Sì: menu, prezzi, foto e orari sono modificabili da te con un pannello semplice, e ti formiamo all'avvio. Se preferisci, ti occupiamo noi degli aggiornamenti.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <SectionHeading
          tag="Domande frequenti"
          title={
            <>
              Le risposte, prima che <em className="italic text-terracotta">le chieda.</em>
            </>
          }
        />

        <Reveal delay={0.1}>
          <Accordion
            type="single"
            collapsible
            className="mt-12 rounded-3xl border border-line bg-panel px-6 sm:px-8"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="border-b border-line last:border-0"
              >
                <AccordionTrigger className="py-6 text-left font-serif text-lg tracking-tight text-bone hover:text-terracotta hover:no-underline sm:text-xl [&>svg]:text-terracotta">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-stone sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}